import { LABEL_SHAPES, LABEL_TYPES, LABEL_STYLES } from "./enums";
import { TEXT_SIZE } from "@/bit/components/components.text";

// Expresión regular para encontrar un numero y redondear los decimales
export function redondearPrecio(texto) {
  const regex = /-?\d+(\.\d+)?/;
  const match = texto.match(regex);

  if (match) {
    const numero = parseFloat(match[0]);
    const tieneDecimales = match[0].includes(".");
    const numeroRedondeado = tieneDecimales
      ? numero.toFixed(2)
      : numero.toString();
    return texto.replace(match[0], numeroRedondeado);
  }

  return texto;
}

export function createCmsLabelProps(props = {}) {
  const {
    shape,
    type,
    text,
    textSize,
    cyData,
    cmsHandler,
    className,
  } = props;

  const res = {
    shape: LABEL_SHAPES.SQUARE,
    type: LABEL_TYPES.INACTIVE,
    color: "",
    opacity: null,
    text: null,
    textSize: TEXT_SIZE.TEXT_PRESET_02,
    cyData: cyData || {},
    cmsHandler: cmsHandler,
    className: `cms-label ${className}`
  };

  // shape
  if (Object.values(LABEL_SHAPES).includes(shape)) {
    res.shape = shape;
  }

  // type
  if (Object.values(LABEL_TYPES).includes(type)) {
    res.type = type;
  }

  if (LABEL_STYLES[res.type]?.color) {
    res.color = LABEL_STYLES[res.type].color;
  }

  // opacity
  if (LABEL_STYLES[res.type]?.opacity) {
    res.opacity = LABEL_STYLES[res.type].opacity;
  }

  // text
  if (text) {
    res.text = redondearPrecio(text);
  }

  if (textSize) {
    res.textSize = textSize;
  }

  // className
  res.className = `${res.className} ${res.shape} ${res.type}`;

  // cms
  if (cmsHandler) {
    if (!text) {
      // Placeholder cms
      res.text = "Label";
      res.shape = LABEL_SHAPES.SQUARE;
      res.type = LABEL_TYPES.INACTIVE;
    }
    res.className = `element-editable ${res.className}`;
  }

  return res;
}
